import { mockClient } from "./mockClient"

export type TenantProfile = {
  id?: number
  name: string
  number_e164: string
  payments_ready: boolean
  whatsapp_ready: boolean
  allow_web_send: boolean
  stripe_webhook: string
  twilio_webhook: string
  demo: boolean
  support_number?: string | null
  brand_logo_url?: string | null
  preferences?: Record<string, unknown>
}

export type QuietHours = {
  enabled: boolean
  start_time: string | null
  end_time: string | null
  timezone: string
}

export type NotificationChannelPreference = {
  digest_enabled: boolean
  quiet_hours?: Record<string, string | null> | null
  updated_at?: string | null
}

export type NotificationPreferencesResponse = {
  weekly_digest: boolean
  weekly_digest_updated_at?: string | null
  last_updated_at?: string | null
  channels: Record<string, NotificationChannelPreference>
}

export async function updateTenantProfile(
  demo: boolean,
  payload: {
    name: string
    support_number?: string | null
    brand_logo_url?: string | null
    allow_web_send: boolean
    notifications?: Record<string, boolean> | null
  },
  token?: string | null,
): Promise<TenantProfile> {
  return mockClient.updateTenantProfile(demo, payload, token) as Promise<TenantProfile>
}

export async function fetchQuietHours(demo: boolean, token?: string | null): Promise<QuietHours> {
  return mockClient.getQuietHours(demo, token) as Promise<QuietHours>
}

export async function setQuietHours(
  demo: boolean,
  payload: { enabled: boolean; start_time?: string | null; end_time?: string | null; timezone?: string | null },
  token?: string | null,
): Promise<QuietHours> {
  return mockClient.setQuietHours(demo, payload, token) as Promise<QuietHours>
}

export async function disconnectStripe(demo: boolean, token?: string | null): Promise<{ ok: true }> {
  return mockClient.disconnectStripe(demo, token) as Promise<{ ok: true }>
}

export async function fetchNotificationPreferences(
  demo: boolean,
  token?: string | null,
): Promise<NotificationPreferencesResponse> {
  return mockClient.getNotificationPreferences(demo, token) as Promise<NotificationPreferencesResponse>
}

export async function updateNotificationPreferences(
  demo: boolean,
  payload: { weekly_digest: boolean; channels: Record<string, { digest_enabled: boolean; quiet_hours?: Record<string, string | null> | null }> },
  token?: string | null,
): Promise<NotificationPreferencesResponse> {
  return mockClient.updateNotificationPreferences(demo, payload, token) as Promise<NotificationPreferencesResponse>
}
